import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unicore-masters',
  templateUrl: './unicore-masters.component.html',
  styleUrls: ['./unicore-masters.component.css']
})
export class UnicoreMastersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/unicore-masters/unicore-masters.component.ts